import { Component } from "react";
import { BrowserRouter , Routes , Route} from "react-router-dom"
import Login from "./pages/Register/login";
import Signup from "./pages/Register/signup";
import ForgottenPassword from "./pages/Register/forgottenPassword";
import PasswordReset from "./pages/Register/passwordreset";
import Dashbaord from "./pages/user/dashboard";
import Withdrawal from "./pages/user/withdrawal";
import Deposit from "./pages/user/deposit";
import Profile from "./pages/user/profile";
import ScrollToTop from "./component/scrollToTop";
import LandingPage from "./pages/landing";
import DepositMethod from "./pages/user/deposit_method";
import WithdrawalMethod from "./pages/user/withdrawal_method";
import EmailConfirmation from "./pages/Register/email_confirmation";
import AdminSignup from "./pages/Register/admin_signup";
import AdminDashboard from "./pages/admin/dashboard";


class App extends Component {
  render() {
    return (
      <BrowserRouter>
        <div className="App">
          <ScrollToTop>
            <Routes>
              <Route exact path="/" element={<LandingPage />} />
              <Route exact path="/login" element={<Login />} />
              <Route exact path="/signup" element={<Signup />} />
              <Route exact path="/Admin_signup" element={<AdminSignup />} />
              <Route exact path="/email-confirmation/:id" element={<EmailConfirmation />} />
              <Route exact path="/forgotten_password" element={<ForgottenPassword />} />
              <Route exact path="/password_reset" element={<PasswordReset />} />

              <Route path="/dashboard" element={<Dashbaord />} />
              <Route path="/withdrawal" element={<Withdrawal />} />
              <Route path="/withdrawal/:method" element={<WithdrawalMethod />} />
              <Route path="/deposit" element={<Deposit />} />
              <Route path="/deposit/:method" element={<DepositMethod />} />
              <Route path="/profile" element={<Profile />} />


              <Route exact path="/Admin_dashboard" element={<AdminDashboard />} />
              {/* <Route exact path="/control_panel" element={<PasswordReset />} />
              <Route exact path="/client_detail/:id" element={<PasswordReset />} />
              <Route exact path="/client_chat/:id" element={<PasswordReset />} /> */}
            </Routes>
          </ScrollToTop>
        </div>
      </BrowserRouter>
    );
  }
}
export default App;
